import { render, staticRenderFns } from "./GFZ.vue?vue&type=template&id=137d6d2c&scoped=true"
import script from "./GFZ.vue?vue&type=script&lang=js"
export * from "./GFZ.vue?vue&type=script&lang=js"
import style0 from "./GFZ.vue?vue&type=style&index=0&id=137d6d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137d6d2c",
  null
  
)

export default component.exports